import { Calendar } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { PodcastEpisode } from '@domain/models/podcast'

interface PodcastCardProps {
  episode: PodcastEpisode
}

function formatReleaseDate(value: Date | undefined): string {
  if (!value) {
    return 'Release date unavailable'
  }

  return value.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export default function PodcastCard({ episode }: PodcastCardProps) {
  return (
    <Link
      to={`/prof-bas-bloem-weekly/${episode.uid}`}
      className="block overflow-hidden rounded-xl bg-card-surface no-underline shadow-lg shadow-black/20 ring-1 ring-black/5 transition-[transform,box-shadow] duration-200 hover:scale-[1.01] hover:shadow-lg hover:shadow-black/30"
    >
      {episode.imageUrl ? (
        <div className="overflow-hidden rounded-t-xl bg-border-light">
          <img
            src={episode.imageUrl}
            alt={episode.name}
            className="h-40 w-full object-cover"
            loading="lazy"
          />
        </div>
      ) : null}

      <div className="p-4">
        <div className="mb-2 flex items-start gap-2 text-xs font-semibold text-primary">
          <Calendar className="mt-0.5 h-3.5 w-3.5" aria-hidden />
          <time>{formatReleaseDate(episode.releaseDate)}</time>
        </div>

        <h3 className="text-lg font-bold text-text-primary">{episode.name}</h3>

        {episode.description ? (
          <p className="mt-2 line-clamp-3 text-sm text-text-primary">
            {episode.description}
          </p>
        ) : null}

        <div className="mt-4 flex items-center gap-2">
          <span className="inline-flex max-w-full rounded-full bg-blue-light px-2.5 py-0.5 text-center text-xs font-bold leading-tight text-blue">
            Podcast
          </span>
          <span className="inline-flex max-w-full rounded-full bg-blue-light px-2.5 py-0.5 text-center text-xs font-bold leading-tight text-blue">
            Video
          </span>
        </div>
      </div>
    </Link>
  )
}
